import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {environment} from '../../../environments/environment';
import swal from 'sweetalert2';
import {finalize} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {
   ILaravelDataTableConfig
} from '../../../../projects/xs-laravel-data-table/src/interfaces/ILaravelDataTableConfig';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
   selector: 'app-manage-book-order',
   templateUrl: './manage-book-order.component.html',
   styleUrls: ['./manage-book-order.component.scss']
})
export class ManageBookOrderComponent implements OnInit {
   @ViewChild('addNew') addNewModal;
   @ViewChild('table') table;
   @ViewChild('orderDetail') orderDetail;
   public selectedItem;
   public endpoint = environment.endpoint + 'admin/book-order/list?type=book';
   public tableConfig: ILaravelDataTableConfig = {
      fields: [
         {name: 'ID', key: 'id', type: 'text', width: 'min'},
         {name: 'Name', key: 'user.name', type: 'text', width: ''},
         {name: 'Amount', key: 'order_total', type: 'text', width: ''},
         {
            name: 'Status',
            key: 'status',
            type: 'text',
            render: (val) => {
               switch (val) {
                  case 'failed':
                     return '<span class="badge p-2 text-uppercase badge-danger">Failed</span>';
                     break;
                  case 'paid':
                     return '<span class="badge p-2 text-uppercase badge-success">Paid</span>';
                     break;
                  case 'pending':
                     return '<span class="badge p-2 text-uppercase badge-warning">Pending</span>';
                     break;
               }
            }
         },
         {
            name: 'Shipping Status', key: 'shipping_status', type: 'text',
         },
         {name: 'label', key: 'label'},
      ],
      actions: [
         {
            name: 'Details',
            type: 'success',
            fn: (dataset, index) => {
               this.selectedOrder = dataset[index];
               this.modal.open(this.orderDetail, {size: 'lg'});
            }
         },

         {
            name: 'Edit Shipping',
            type: 'primary',
            fn: (dataset, index) => {
               this.selectedItem = dataset[index];
               this.form.patchValue(this.selectedItem);
               this.form.patchValue({
                  courier_service: this.selectedItem.shipping_info?.courier_service,
                  courier_service_number: this.selectedItem.shipping_info?.courier_service_number,
                  tracking_url: this.selectedItem.shipping_info?.tracking_url,
                  dispatch_date: this.selectedItem.shipping_info?.dispatch_date,
               })
               const modalRef = this.modal.open(this.addNewModal, {size: 'lg'});

            }
         },
         {
            name: 'Delete',
            type: 'danger',
            fn: (dataset, index) => {
               swal.fire({
                  title: 'Delete :' + dataset[index].title + '?',
                  icon: 'question',
                  showCancelButton: true,
                  cancelButtonText: 'No',
                  confirmButtonText: 'Yes',
               }).then(res => {
                  if (res.value) {
                     this.loader.start();
                     this.api.post('admin/book-order/delete', {id: dataset[index].id})
                        .pipe(finalize(() => {
                           this.loader.stop();
                        }))
                        .subscribe((res: any) => {
                           dataset.splice(index, 1);
                        });
                  }
               });
            }
         }
      ]
   };
   selectedOrder: any;
   public form: FormGroup

   constructor(
      public toastr: ToastrService,
      public api: ApiService,
      public auth: AuthService,
      public router: Router,
      public modal: NgbModal,
      public loader: NgxUiLoaderService,
   ) {
   }

   pdf() {
      const documentDefinition = {
         info: {
            title: 'awesome Document',
            author: 'john doe',
            subject: 'subject of document',
            keywords: 'keywords for document',
         },
         content: [
            {
               columns: [
                  {
                     // tslint:disable-next-line:max-line-length
                     fit: [200, 400],
                     image: 'logo',
                  },
                  {
                     text: 'An Initiative by Munish Jindal, Author - Sadda Punjab',
                     style: 'small'
                  }
               ],

            },
            {
               style: 'orderTable',
               table: {
                  body: [
                     ['Order ID', 100],
                     ['Order Date', 100],
                     ['Order Amount', 100],
                  ]
               }
            }
         ],
         styles: {
            orderTable: {
               fontSize: 10,
               margin: [0, 20, 0, 0]
            },
            small: {
               fontSize: 10,
               margin: [0, 10, 0, 0]
            }
         },
         images: {
            logo: 'data:image/jpeg;base64,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'
         }
      };

      pdfMake.createPdf(documentDefinition).open();
   }

   ngOnInit() {
      this.form = new FormGroup({
         id: new FormControl(),
         courier_service: new FormControl<string>(''),
         courier_service_number: new FormControl<string>(''),
         tracking_url: new FormControl<string>(''),
         dispatch_date: new FormControl<string>(''),
         shipping_status: new FormControl<string>(''),
      })
   }

   add(
      addNew: TemplateRef<any>) {
      this.selectedItem = null;
      this.form.reset();
      this.modal.open(addNew, {size: 'lg'});
   }

   save() {
      this.loader.start();
      this.api.post('admin/order/updateShipping', this.form.value)
         .pipe(finalize(() => {
            this.loader.stop();
         }))
         .subscribe((res: any) => {
            this.modal.dismissAll();
            this.table.loadData();
         });
   }
}
